var youbora = require('youboralib')
var manifest = require('../../manifest.json')

var AdsAdapter = youbora.Adapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech + '-ads'
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    if (this.player) {
      return this.player.getPlayheadTime() || this.playhead
    }
    return this.playhead
  },

  /** Override to return video duration */
  getDuration: function () {
    if (this.player) {
      return this.player.getDuration() || this.duration
    }
    return this.duration
  },

  /** Override to return current bitrate */
  getBitrate: function () {
    if (this.player) {
      return this.player.getCurrentBitrate() || this.bitrate
    }
    return this.bitrate
  },

  /** Override to return rendition */
  getRendition: function () {
    return this.rendition
  },

  /** Override to return title */
  getTitle: function () {
    if (this.player) {
      return this.player.getTitle() || this.title
    }
    return this.title
  },

  /** Override to return resource URL. */
  getResource: function () {
    return "unknown"
  },

  /** Override to return player version */
  getPlayerVersion: function () {
    return OO.VERSION.core.rev
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return "Ooyala"
  },

  getPosition: function () {
    if (this.plugin._adapter.getPlayhead() === this.plugin._adapter.getDuration()) {
      return 'post'
    } else if (!this.plugin._adapter.getPlayhead()) {
      return 'pre'
    }
    return 'mid'
  },

  processEvent: function (eventName, params) {
    try {
      var Event = OO.Analytics.EVENTS
      switch (eventName) {
        case Event.VIDEO_STREAM_POSITION_CHANGED:
          this.playhead = params[0].streamPosition
          this.duration = params[0].totalStreamDuration
          if (this.flags.isPaused && (this.playhead > this.clickPlayhead + 1)) {
            this.clickPlayhead = null
            this.fireResume()
          }
          break
        case Event.AD_STARTED:
          this.playhead = 0
          if (params[0].adMetadata) {
            this.duration = params[0].adMetadata.adDuration
            this.title = params[0].adMetadata.adId
          }
          if (!this.plugin.getAdapter().flags.isStarted) this.plugin.getAdapter().fireStart()
          this.fireStart()
          this.monitorPlayhead(true, false, 1200)
          break
        case Event.AD_POD_ENDED:
        case Event.AD_BREAK_ENDED:
          this.plugin._adapter.isShowingAds = false
          this.plugin._adapter.fireResume()
        case Event.AD_ENDED:
        case Event.AD_COMPLETED:
          this.fireStop()
          break
        case Event.AD_SKIPPED:
          this.fireStop({ skipped: true })
          break
        case Event.VIDEO_PLAYING:
        case Event.AD_IMPRESSION:
          this.fireJoin()
          this.fireResume()
          break
        case Event.VIDEO_PAUSED:
          this.firePause()
          break
        case Event.VIDEO_CONTENT_METADATA_UPDATED:
          this.title = params[0].title
          this.duration = params[0].duration / 1000
          break
        case Event.BITRATE_INITIAL:
          this.bitrate = params[0].bitrate
          if (isNaN(params[0].id)) {
            this.rendition = params[0].id
          } else if (params[0].width && params[0].height && params[0].bitrate) {
            this.rendition = youbora.Util.buildRenditionString(params[0].width, params[0].height, params[0].bitrate)
          } else {
            this.rendition = null
          }
          break
        case Event.AD_ERROR:
          this.fireError("ad_error", params[0].error)
          this.fireStop()
          this.playhead = 0
          this.plugin._adapter.isShowingAds = false
          break
        case Event.AD_CLICKTHROUGH_OPENED:
          this.clickPlayhead = this.playhead
          this.fireClick()
          this.firePause()
          break
      }
    } catch (error) {
      youbora.Log.error(error)
    }

  }
})

module.exports = AdsAdapter
